export default __webpack_public_path__ + "static/media/flip-cam.69a65d06.svg";